export type MeridianColorScheme = 'light' | 'dark';

export const tokens = {
  light: {
    bg: {
      default: '#FAFAF9',
      surface: '#FFFFFF',
      muted: '#F5F5F4',
      sunken: '#F5F5F4',
      overlay: '#FFFFFF',
    },
    border: {
      default: '#E7E5E4',
      strong: '#D6D3D1',
      subtle: '#EFEDEC',
    },
    text: {
      default: '#1C1917',
      secondary: '#78716C',
      tertiary: '#A8A29E',
      onAccent: '#FFFFFF',
    },
    accent: {
      default: '#1A6DD4',
      hover: '#1558B0',
      light: '#EBF2FC',
      soft: '#E8F0FB',
      text: '#1A6DD4',
    },
    success: {
      default: '#059669',
      light: '#DDFBE8',
      soft: '#E5F3EB',
    },
    warning: {
      default: '#D97706',
      light: '#FEF3C7',
      soft: '#FDF3E7',
    },
    error: {
      default: '#DC2626',
      light: '#FEE2E2',
      soft: '#FBE9E8',
    },
    info: {
      default: '#6E56CF',
      soft: '#EFEBFB',
    },
    shadow: {
      xs: '0 1px 1px rgba(28, 25, 23, 0.04)',
      sm: '0 1px 2px rgba(28, 25, 23, 0.06), 0 1px 1px rgba(28, 25, 23, 0.04)',
      md: '0 4px 12px rgba(28, 25, 23, 0.08), 0 1px 2px rgba(28, 25, 23, 0.04)',
      lg: '0 16px 40px rgba(28, 25, 23, 0.12), 0 2px 6px rgba(28, 25, 23, 0.04)',
    },
    sidebar: {
      bg: '#1C1917',
      dark: '#111821',
      activeItemBg: 'rgba(26,109,212,0.1)',
      divider: 'rgba(255,255,255,0.1)',
    },
  },
  dark: {
    bg: {
      default: '#161514',
      surface: '#1E1D1B',
      muted: '#2A2926',
      sunken: '#0F0F0E',
      overlay: '#292524',
    },
    border: {
      default: '#363530',
      strong: '#4A4642',
      subtle: '#2A2624',
    },
    text: {
      default: '#EDECEA',
      secondary: '#9B9A95',
      tertiary: '#6B6A65',
      onAccent: '#FFFFFF',
    },
    accent: {
      default: '#4A9AEE',
      hover: '#3A88DC',
      light: '#1A2A3D',
      soft: '#16273D',
      text: '#6DB3F8',
    },
    success: {
      default: '#34D07B',
      light: '#132E1E',
      soft: '#0E2A1A',
    },
    warning: {
      default: '#F5A623',
      light: '#2E2210',
      soft: '#2E2113',
    },
    error: {
      default: '#F06060',
      light: '#2E1414',
      soft: '#2E1716',
    },
    info: {
      default: '#A992F0',
      soft: '#1E1A2E',
    },
    shadow: {
      xs: '0 1px 1px rgba(0,0,0,0.3)',
      sm: '0 1px 2px rgba(0,0,0,0.4), 0 1px 1px rgba(0,0,0,0.3)',
      md: '0 4px 12px rgba(0,0,0,0.45), 0 1px 2px rgba(0,0,0,0.3)',
      lg: '0 16px 40px rgba(0,0,0,0.55), 0 2px 6px rgba(0,0,0,0.3)',
    },
    sidebar: {
      bg: '#111821',
      dark: '#0C1119',
      activeItemBg: 'rgba(74,154,238,0.1)',
      divider: 'rgba(255,255,255,0.08)',
    },
  },
} as const;
